import { createFileRoute } from '@tanstack/react-router';

import { AgencyPage } from '@/components/agency/agency-page';
import { TeamTab } from '@/components/settings/team/team-tab';
import { loadNamespaces } from '@/lib/i18n/i18n';

export const Route = createFileRoute('/_authenticated/agency/team')({
  loader: () => loadNamespaces('agency', 'settings'),
  staticData: {
    title: 'route.agency_team.title',
  },
  component: AgencyTeamRoute,
});

function AgencyTeamRoute(): React.ReactElement {
  return (
    <AgencyPage>
      <TeamTab />
    </AgencyPage>
  );
}
